import { render } from "./MainDetalProductPage.vue?vue&type=template&id=5e6531b0&scoped=true"
import script from "./MainDetalProductPage.vue?vue&type=script&lang=js"
export * from "./MainDetalProductPage.vue?vue&type=script&lang=js"

import "./MainDetalProductPage.vue?vue&type=style&index=0&id=5e6531b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6531b0"]])

export default __exports__